'use es6';

import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import ReviewRenderer from 'marketplace-ui-details/reviews/ReviewRenderer';
import { EcosystemReviewsList } from 'marketplace-ui-reviews/components/display/EcosystemReviewsList';
import { EcosystemReviewsStats } from 'marketplace-ui-reviews/components/display/EcosystemReviewsStats';
import { useSelector } from 'react-redux';
import { getIsPublicApp } from '../../selectors/app';
import { getServices } from '../../slices/serviceCatalogSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReviewsCardBody = ({
  profileId
}) => {
  const {
    inline
  } = useResponsiveProps({
    inline: {
      xs: false,
      lg: true
    }
  });
  const catalogServices = useSelector(getServices);
  const isPublicApp = useSelector(getIsPublicApp);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EcosystemReviewsStats, {
      appContext: isPublicApp ? 'public' : 'app',
      flexDirection: inline ? 'row' : 'column',
      marginBlock: "600",
      offeringId: profileId,
      ratingKey: "OVERALL",
      reviewType: "PROFILE",
      justifyContent: "space-between"
    }), /*#__PURE__*/_jsx(EcosystemReviewsList, {
      appContext: isPublicApp ? 'public' : 'app',
      expandable: false,
      offeringId: profileId,
      ReviewRenderer: ReviewRenderer,
      reviewRendererProps: {
        catalogServices
      },
      reviewType: "PROFILE",
      searchable: true
    })]
  });
};
export default ReviewsCardBody;